// extracted by mini-css-extract-plugin
module.exports = {"friends-list":"BeneficiariesList_friends-list__3lRyE","button":"BeneficiariesList_button__ZchWa"};